import { getLookupList, sortLookupOptionsByLabel } from "../utils/apiUtils"
import { ENTITY_NAME_PRODUCT, ENTITY_NAME_PRODUCT_TYPE } from "./dbConstants";

export const getListOptions = async(input) => {
  const companyId = input?.companyId;
  if(!companyId) {
    return []
  }
  return sortLookupOptionsByLabel(await getLookupList(ENTITY_NAME_PRODUCT, {companyId}))
}

export const getTypeListOptions = async(input) => {
  console.log("ProductDAO.getTypeListOptions - input:", input);
  const companyId = input?.companyId;
  if(!companyId) {
    return []
  }
  return getLookupList(ENTITY_NAME_PRODUCT_TYPE, {companyId})
}

export const getAllTypeListOptions = async(input) => {
  console.log("ProductDAO.getTypeListOptions - input:", input);
  const companyId = input?.companyId ?? '';
  return getLookupList(ENTITY_NAME_PRODUCT_TYPE, {companyId, all: true})
}
